import { NitrogenSimulationType } from "./enums";

export interface SimulationStatistics {
    id: number;
    date: string;
    nitrogen_uptake: number;
    nitrogen_applied: number;
    CWAD: number;
    NUPC: number;
    soil_residual_nitrogen_surplus: number;
    remobilization: number;
    simulation: number;
}

export enum ProcessingStatus {
    PENDING = "PENDING",
    PROCESSING = "PROCESSING",
    PARTIALLY_COMPLETED = "PARTIALLY_COMPLETED",
    COMPLETED = "COMPLETED",
    FAILED = "FAILED",
}

export interface NitrogenPlan {
    id: number;
    field: number;
    date: string;
    simulations: NitrogenPlanSimulation[];
    processing_status: ProcessingStatus;
}

export interface NitrogenPlanSimulation {
    id: number;
    product: number;
    initial_rate: number;
    current_rate: number;
    simulation_type: NitrogenSimulationType;
    rates: NitrogenPlanSimulationRate[];
    total_nitrogen_applied: number;
    final_harvestable_weight: number;
    penalty_early_CWAD: number;
    penalty_NIAD: number;
    penalty_remob: number;
    penalty_roi: number;
    penalty_early_NUPC: number;
    processing_status: ProcessingStatus;
    minimum_rate: number;
    maximum_rate: number;
    imagery_rate: number;
    imagery_minimum_rate: number;
    imagery_maximum_rate: number;
}

export interface NitrogenPlanSimulationRate {
    id: number;
    simulation_zone: number;
    initial_rate: number;
    current_rate: number;
}
